import React from 'react';
import OptionalModal from './OptionalModal';

const defaultOptions = {
  title: 'Are you sure you want to exit without changes?',
  text: '',
  cancelBtnText: 'Discard',
  saveBtnText: 'Save',
};

const UnsavedChangesModal = ({ isOpen, onDiscard, onSave, onClose, options }) => (
  <OptionalModal
    isOpen={isOpen}
    onClose={onClose}
    onCancel={onDiscard}
    onSave={onSave}
    options={{ ...defaultOptions, ...options }}
  />
);

export default UnsavedChangesModal;
